import React, { useState } from "react";
import { FaAngleDoubleDown, FaAngleDoubleUp, FaChevronDown } from "react-icons/fa";
import ProjectSummary from "./ProjectSummary";
import { ProjectBriefDetails, SocialAccountsList } from "./TenantOverview";

const SECTION_KEYS = ["brief", "accounts", "results"];
const DEFAULT_OPEN = { brief: false, accounts: false, results: true };

function OverviewSection({ id, title, open, onToggle, action, children }) {
  const bodyId = `dmp-overview-${id}`;
  return (
    <section className={`dmp-section${open ? " is-open" : ""}`}>
      <div className="dmp-section__head" onClick={onToggle}>
        <h3 className="dmp-section__title">{title}</h3>
        {action ? (
          <div className="dmp-section__action" onClick={(e) => e.stopPropagation()}>
            {action}
          </div>
        ) : null}
        <button
          type="button"
          className="dmp-section__toggle"
          aria-expanded={open}
          aria-controls={bodyId}
          aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          <FaChevronDown aria-hidden="true" />
        </button>
      </div>
      <div id={bodyId} className="dmp-section__body" hidden={!open}>
        {children}
      </div>
    </section>
  );
}

/** Overview tab: project brief, social accounts and results as collapsible sections of one card. */
function ProjectOverview({ api, projectId, refreshKey, project, accounts, onManageAccounts }) {
  const [open, setOpen] = useState(DEFAULT_OPEN);
  const setAll = (value) => setOpen(Object.fromEntries(SECTION_KEYS.map((key) => [key, value])));
  const toggle = (key) => () => setOpen((o) => ({ ...o, [key]: !o[key] }));

  return (
    <>
      <div className="dmp-section-controls">
        <button type="button" className="dmp-link-btn" onClick={() => setAll(true)}>
          <FaAngleDoubleDown aria-hidden="true" />
          Expand all
        </button>
        <button type="button" className="dmp-link-btn" onClick={() => setAll(false)}>
          <FaAngleDoubleUp aria-hidden="true" />
          Collapse all
        </button>
      </div>
      <div className="dmp-sections">
        <OverviewSection id="brief" title="Project Brief" open={open.brief} onToggle={toggle("brief")}>
          <ProjectBriefDetails project={project} />
        </OverviewSection>
        <OverviewSection
          id="accounts"
          title="Social Accounts"
          open={open.accounts}
          onToggle={toggle("accounts")}
          action={
            onManageAccounts ? (
              <button type="button" className="dmp-btn dmp-btn--ghost dmp-btn--sm" onClick={onManageAccounts}>
                Manage accounts
              </button>
            ) : null
          }
        >
          <SocialAccountsList accounts={accounts} />
        </OverviewSection>
        <OverviewSection id="results" title="Results" open={open.results} onToggle={toggle("results")}>
          <ProjectSummary api={api} projectId={projectId} refreshKey={refreshKey} compact embedded />
        </OverviewSection>
      </div>
    </>
  );
}

export default ProjectOverview;
